import React from 'react';
import './AboutUs.css';
import { Link } from 'react-router-dom';

function AboutUs() {
  return (
    <div className="about-page">
      <div className="about-container">
        <h1>Welcome to Pure-Paths</h1>
        
        <div className="about-content">
          <p className="intro-text">
            At Pure-Paths, we are dedicated to revolutionizing workplace well-being through cutting-edge AI technology. 
            Our mission is to transform the way businesses understand and support their employees, creating environments 
            where both individuals and organizations thrive.
          </p>

          <div className="content-section">
            <h2>Who We Are</h2>
            <p>
              Founded with a vision to bridge the gap between technology and human experience, we specialize in delivering 
              innovative AI-driven solutions that enhance employee engagement, satisfaction, and overall workplace harmony. 
              Our team of experts combines deep industry knowledge with advanced technology to provide actionable insights 
              and support to businesses of all sizes.
            </p>
          </div>

          <div className="content-section">
            <h2>Our Mission</h2>
            <p>
              Our mission is to empower companies to build better workplaces by leveraging artificial intelligence to gain 
              a deeper understanding of employee needs and experiences. We believe that a motivated and content workforce 
              is the key to long-term success and productivity. Through our solutions, we aim to foster a culture of 
              openness, growth, and mutual respect.
            </p>
          </div>

          <div className="content-section">
            <h2>Our Services</h2>
            <div className="services-list">
              <div className="service-item">
                <h3>AI-Driven Insights</h3>
                <p>Advanced AI tools collect and analyze employee feedback, providing valuable insights into work experiences, challenges, and aspirations.</p>
              </div>
              <div className="service-item">
                <h3>Personalized Support</h3>
                <p>Tailored recommendations and solutions based on the unique needs of your workforce, helping to resolve issues before they escalate.</p>
              </div>
              <div className="service-item">
                <h3>Continuous Improvement</h3>
                <p>Ongoing engagement platform offering regular check-ins and actionable feedback to help enhance the work environment.</p>
              </div>
              <div className="service-item">
                <h3>Confidential Communication</h3>
                <p>Anonymous communication channels ensuring employees feel safe and supported in expressing their concerns and suggestions.</p>
              </div>
            </div>
          </div>

          <div className="content-section">
            <h2>Why Pure-Paths?</h2>
            <p>
              Our commitment to excellence directly translates into measurable financial benefits for your organization. 
              By implementing our AI-driven solutions, companies typically see:
            </p>
            <ul className="benefits-list">
              <li>
                <strong>Reduced Turnover Costs:</strong> By identifying and addressing employee concerns early, 
                organizations save significantly on recruitment and training costs, which can amount to 150% of an 
                employee's annual salary.
              </li>
              <li>
                <strong>Increased Productivity:</strong> Engaged employees are up to 21% more productive, directly 
                impacting your bottom line. Our platform ensures your workforce remains motivated and efficient.
              </li>
              <li>
                <strong>Enhanced Revenue Growth:</strong> Companies with highly engaged employees see 2.5x more 
                revenue growth compared to competitors with lower engagement levels, as satisfied employees deliver 
                better customer service and drive innovation.
              </li>
              <li>
                <strong>Cost-Effective Decision Making:</strong> Our real-time AI analytics help you make data-driven 
                decisions about workplace improvements, ensuring your investments in employee well-being deliver 
                maximum ROI.
              </li>
            </ul>
            <p>
              Whether you're a growing startup or an established enterprise, our scalable platform adapts to your needs, 
              ensuring every investment in employee well-being translates directly to improved financial performance 
              and sustainable business growth.
            </p>
          </div>

          <div className="content-section">
            <h2>Our Vision for the Future</h2>
            <p>
              We envision a world where every workplace is a thriving ecosystem of engaged, valued, and empowered individuals. 
              By partnering with Pure-Paths, you're not just implementing a solution – you're investing in a future where 
              employee well-being and business success go hand in hand.
            </p>
          </div>

          <div className="cta-section">
            <p>
              Ready to transform your workplace? Contact us today to learn how Pure-Paths can help you build a more engaged, 
              satisfied, and productive workforce.
            </p>
            <Link to="/contact" className="contact-button">Get Started</Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUs; 